import { createReducer } from '/@/store/utils';
import * as actions from './actions';

export default createReducer(
    {
        historyId: 0,
        stack: [],
        direction: 'left',
        menuOpened: false,
        activeView: null,
        selectedFeature: [],
        showTermsAndConditions: undefined,
        goBack: undefined,
    },
    {
        [actions.setView]: (state, action) => {
            return {
                ...state,
                activeView: action.payload,
            };
        },
        [actions.openMenu]: (state) => ({ ...state, menuOpened: true }),
        [actions.closeMenu]: (state) => ({ ...state, menuOpened: false }),
        [actions.closeMenuFromOverlay]: (state) => ({ ...state, menuOpened: false }),
        [actions.closeMenuFromIcon]: (state) => ({ ...state, menuOpened: false }),
        [actions.setShowTermsAndConditions]: (state, action) => ({ ...state, showTermsAndConditions: action.payload }),
        [actions.setSelectedFeature]: (state, action) => ({ ...state, selectedFeature: action.payload }),
        [actions.setGoBack]: (state, action) => ({ ...state, goBack: action.payload }),
    }
);
